module.exports = __webpack_public_path__ + "static/trust_agencyvista1-35d52e6fec1c1962c4639bcfa1778361.png";